import { useState } from 'react';
import Tooltip from '@/components/Tooltip';
import { useI18nText } from '@/lib/utils/i18nText';
import { getChannelTypeMetricIcon } from '@/lib/utils/channelPlatformMeta';
import { formatNum } from '../utils';

/* ──────────────────── 캠페인 통계 사이드바 ──────────────────── */

export function CampaignStatsSidebar({ analysis }: {
  analysis: { total?: { youtube?: Record<string, number>; clicks?: Record<string, number> } };
}) {
  const [open, setOpen] = useState(true);
  const { t } = useI18nText();
  const ytStats = analysis?.total?.youtube;
  const clickStats = analysis?.total?.clicks;

  // 실제 데이터가 하나도 없으면 섹션 전체 숨김
  const hasYtData = (ytStats?.views ?? 0) > 0 || (ytStats?.likes ?? 0) > 0 || (ytStats?.comments ?? 0) > 0;
  const hasClickData = clickStats
    ? Object.values(clickStats).some((v) => (v ?? 0) > 0)
    : false;
  if (!hasYtData && !hasClickData) return null;

  return (
    <div className="filter-section campaign-stats-section">
      <div className="campaign-stats-toggle">
        <i className="fa fa-bar-chart campaign-stats-toggle-icon" />
        <span>{t('Campaign statistics', '캠페인 통계')}</span>
        <Tooltip content={t('Click to expand or collapse', '클릭하면 펼치기/접기가 가능합니다')}>
          <button type="button" className="campaign-stats-toggle-caret-btn" onClick={() => setOpen((p) => !p)}>
            <i className={`fa fa-caret-${open ? 'up' : 'down'}`} />
          </button>
        </Tooltip>
      </div>
      {open && (
        <div className="campaign-stats-body">
          <div className="campaign-stats-columns">
            <div className="campaign-stats-group">
              <div className="campaign-stats-group-title">
              </div>
              <Tooltip content={t('Total video views', '총 영상 조회수')}>
                <div className="campaign-stats-row"><i className={`fa fa-${getChannelTypeMetricIcon('youtube', 'views')}`} /> <span>{t('Views', '조회수')}</span> <strong>{ytStats ? formatNum(ytStats.views) : ''}</strong></div>
              </Tooltip>
              <Tooltip content={t('Total video likes', '총 영상 좋아요')}>
                <div className="campaign-stats-row"><i className={`fa fa-${getChannelTypeMetricIcon('youtube', 'likes')}`} /> <span>{t('Likes', '좋아요')}</span> <strong>{ytStats ? formatNum(ytStats.likes) : ''}</strong></div>
              </Tooltip>
              <Tooltip content={t('Total video comments', '총 영상 댓글')}>
                <div className="campaign-stats-row"><i className={`fa fa-${getChannelTypeMetricIcon('youtube', 'comments')}`} /> <span>{t('Comments', '코멘트')}</span> <strong>{ytStats ? formatNum(ytStats.comments) : ''}</strong></div>
              </Tooltip>
            </div>
            <div className="campaign-stats-group border-l border-ggc-border-gray pl-2">
              <div className="campaign-stats-group-title">
                <i className="fa fa-mouse-pointer text-ggc-text-gray" /> {t('Clicks', '클릭')}</div>
                <Tooltip content={t('Web link clicks', '웹 링크 클릭')}>
                  <div className="ml-2 campaign-stats-row"><i className="fa fa-globe" /> <span>{t('Web', '웹')}</span> <strong>{clickStats ? formatNum(clickStats.web ?? clickStats.gameWebURL) : ''}</strong></div>
                </Tooltip>
                <Tooltip content={t('iOS app clicks', 'iOS 앱 클릭')}>
                  <div className="ml-2 campaign-stats-row"><i className="fa fa-apple" /> <span>iOS</span> <strong>{clickStats ? formatNum(clickStats.ios ?? clickStats.gameiOSURL) : ''}</strong></div>
                </Tooltip>
                <Tooltip content={t('Android app clicks', 'Android 앱 클릭')}>
                  <div className="ml-2 campaign-stats-row"><i className="fa fa-android" /> <span>Android</span> <strong>{clickStats ? formatNum(clickStats.android ?? clickStats.gameAndroidURL) : ''}</strong></div>
                </Tooltip>
                {(clickStats?.defaultURL ?? 0) > 0 && (
                  <Tooltip content={t('Other link clicks', '기타 링크 클릭')}>
                    <div className="ml-2 campaign-stats-row"><i className="fa fa-hand-pointer-o" /> <span>{t('Other', '기타')}</span> <strong>{formatNum(clickStats?.defaultURL)}</strong></div>
                  </Tooltip>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
